import { KnBrCustomerService } from "./../../store/kn-br-customer/kn-br-customer.service";
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation,
  OnDestroy,
} from "@angular/core";
import {
  AuthService,
  CmsService,
  RoutingService,
  WindowRef,
} from "@spartacus/core";
import { Observable, Subject, Subscription } from "rxjs";
import { distinctUntilChanged, filter, map, takeUntil } from "rxjs/operators";
import { KnBrCommonService } from "src/app/services/kn-br-common.service";

import { KnBrCustomerContextService } from "../../store/kn-br-customer-context/kn-br-customer-context.service";
import { CustomerData } from "./../../models/customer.model";
import { KnBrSidebarService } from "./../../services/kn-br-sidebar.service";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { NgbModal, NgbDropdown } from "@ng-bootstrap/ng-bootstrap";
import { ContextModalComponent } from "./context-change-modal/context-change-modal.component";
import { KnBrCartContextService } from "src/app/store/kn-br-cart-context/kn-br-cart-context.service";
import { Cart, MultiCartFacade, OrderEntry } from "@spartacus/cart/base/root";
import { MiniCartComponentService } from "@spartacus/cart/base/components/mini-cart";
import { ActiveCartService } from "@spartacus/cart/base/core";
import { KnBrCheckoutService } from "src/app/services/kn-br-checkout-service";
import { Router } from "@angular/router";
import { CheckoutFlowService } from "src/app/knbr-dual-checkout/checkout-flow-service";
import { EditCartConfirmationModalComponent } from "src/app/knbr-dual-checkout/edit-cart-confirmation-modal/edit-cart-confirmation-modal.component";
import { OutletRefDirective, GlobalMessageComponent, PageLayoutComponent, PageSlotComponent, MediaComponent } from "@spartacus/storefront";
import { NgIf, NgClass, NgFor, AsyncPipe } from "@angular/common";
import { RemoveLeadingZerosPipe } from "../../shared/pipe/kn-br-custom-pipes/remove-leading-zeros.pipe";
import { Auth0Service } from "src/app/services/knbr-new-auth0.service";

@Component({
    selector: "kn-br-outlet",
    templateUrl: "./kn-br-outlet.component.html",
    styleUrls: ["./kn-br-outlet.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [
        OutletRefDirective,
        NgbDropdown,
        NgClass,
        GlobalMessageComponent,
        PageLayoutComponent,
        PageSlotComponent,
        MediaComponent,
        AsyncPipe,
        RemoveLeadingZerosPipe,
    ],
})
export class KnBrOutletComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  isOrderConfirmation = false;
  isHeaderHidden = false;
  customerContext$: Observable<CustomerData> = this.customerContextService.get$;
  isLoggedIn$: Observable<boolean> = this.authService.isUserLoggedIn();
  redirectionDetail$: Observable<any> =
    this.knBrCommonService.redirectionDetail$;
  customersDataList$: Observable<any> =
    this.knBrCommonService.loadCustomersData$();
  user$ = this.userService.get();
  selectedCustomer;
  subscription = new Subscription();
  pageTemplateName = "";
  modalRef;
  isActive = false;
  soldToAccountsList = [];
  isOpenMiniCartDropdown: boolean = false;
  quantity$: Observable<any> = this.miniCartComponentService.getQuantity();
  cartContext$: Observable<string> = this.knBrCartContextService.get$;
  userAccountApiRespAccountNumber;
  hideCart = false;

  total$: Observable<string> = this.activeCartService.getActive().pipe(
    filter((cart) => !!cart.totalPrice),
    map((cart) => cart.totalPrice.formattedValue)
  );
  subTotal$: Observable<string> = this.activeCartService.getActive().pipe(
    filter((cart) => !!cart.subTotal),
    map((cart) => cart.subTotal.formattedValue)
  );

  readonly isLoginPage$ = this.cmsService
    .getCurrentPage()
    .pipe(
      map(
        (page) =>
          page &&
          (page.template === "CwtLoginPageTemplate" ||
            page.template === "knBrQuoteSellerApproverTemplate" ||
            page.template === "KnBrRegistrationPageTemplate")
      )
    );
  readonly isUndefinedPage$ = this.cmsService
    .getCurrentPage()
    .pipe(
      map(
        (page) =>
          !page ||
          page.template === "knBrQuoteSellerApproverTemplate" ||
          page.template === "ContentPage1Template"
      )
    );
  readonly hideBreadCrumb$ = this.cmsService
    .getCurrentPage()
    .pipe(
      map(
        (page) =>
          page &&
          (page.template === "CwtLandingPage2Template" ||
            page.template === "KnBrSearchResultsListPageTemplate" ||
            page.template === "KnBrProductListPageTemplate" ||
            page.template === "KnBrProductGridPageTemplate" ||
            page.template === "KnBrSearchResultsGridPageTemplate" ||
            page.template === "KnBrProductDetailsPageTemplate")
      )
    );
  readonly isStaticPage$ = this.cmsService
    .getCurrentPage()
    .pipe(map((page) => page && page.template === "ContentPage1Template"));
  miniCart$: Observable<Cart>;
  cartId: string;
  cartEntries$: Observable<OrderEntry[]>;
  avatarName = "";
  isCheckout = false;
  showEditCartConfirmationDialog = false;

  constructor(
    private cmsService: CmsService,
    private customerContextService: KnBrCustomerContextService,
    private userService: UserAccountFacade,
    private sidebarService: KnBrSidebarService,
    private knBrCommonService: KnBrCommonService,
    private KnBrCheckoutService: KnBrCheckoutService,
    protected checkoutFlowService: CheckoutFlowService,
    protected authService: AuthService,
    private customerSearchService: KnBrCustomerService,
    protected routing: RoutingService,
    private modalService: NgbModal,
    private knBrCartContextService: KnBrCartContextService,
    private multiCartFacade: MultiCartFacade,
    protected miniCartComponentService: MiniCartComponentService,
    protected activeCartService: ActiveCartService,
    private newAuth0Service: Auth0Service,
    private winRef: WindowRef,
    private router: Router
  ) {
    this.knBrCartContextService.get$.subscribe((response) => {
      this.cartId = response ? response : null;
    });

    this.subscription.add(
      this.checkoutFlowService.cartCreditInfo$.subscribe((resp) => {
        this.showEditCartConfirmationDialog = resp;
      })
    );
    this.subscription.add(
      this.cmsService.getCurrentPage().subscribe((page) => {
        if (page) {
          this.pageTemplateName = page.template;
          if (page?.pageId === "CwtRegistrationPage" || page?.pageId === 'CwtSupportPage' || page?.pageId === 'cwtLogout') {
            this.hideCart = true;
          }
        }
      })
    );
    this.subscription.add(
      this.user$.subscribe((user: any) => {
        if (user && user?.orgUnit?.uid) {
          this.knBrCommonService.getCustomersData();
          this.userAccountApiRespAccountNumber = user?.orgUnit?.uid;
          this.avatarName = user?.name.match(/\b(\w)/g).join("");
        }
      })
    );
    this.customersDataList$.subscribe((res) => {
      if (res) {
        this.soldToAccountsList = res;
      }
    });
    this.subscription.add(
      this.KnBrCheckoutService.getCheckoutFlag().subscribe((res) => {
        this.isCheckout = res;
      })
    );
    this.subscription.add(
      this.KnBrCheckoutService.getOrderConfirmationFlag().subscribe((res) => {
        this.isOrderConfirmation = res;
      })
    );
  }

  ngOnInit() {
    /**
     * commenting this as we need redirection everytime to home page itself
     * this was done to eliminate duplicate switch account page api calls
     * as we dont have switch account page anymore
     * we might consider this if that page comes here again
     */
    // this.subscription.add(
    //   this.isLoggedIn$.pipe(distinctUntilChanged()).subscribe((res) => {
    //     if (res) {
    //       this.knBrCommonService
    //         .getRedirectionDetail()
    //         .subscribe((redirect: any) => {
    //           if (redirect?.redirectURL === "/switch-account") {
    //             const hasContext = this.winRef.localStorage.getItem(
    //               "kn-br-customer-context"
    //             );
    //             if (!hasContext) {
    //               this.routing.goByUrl("/");
    //               this.knBrCommonService.redirectionDetail$.next(redirect);
    //             } else if (
    //               this.soldToAccountsList &&
    //               this.soldToAccountsList?.length > 1
    //             ) {
    //               this.routing.goByUrl("/");
    //               this.changeCustomerContext();
    //             }
    //           }
    //         }, (error) => { }, () => {
    //           // loader added in login button
    //           this.knBrCommonService.showSpinner$.next(false);
    //         });
    //     }
    //   })
    // );

            this.subscription.add(
      this.isLoggedIn$.subscribe((res) => {
        if (res) {
            this.knBrCommonService.getRedirectionDetail().pipe(takeUntil(this.destroy$)).subscribe({
              next: (redirect) => {
              },
              error: (error) => {
                console.error('Error occurred while fetching redirection detail:', error);
                this.logout();
              }
            });
        }
      })
    );

    this.subscription.add(
      this.customerContextService.get$.subscribe((customerdata) => {
        this.selectedCustomer = customerdata;
      })
    );
    this.subscription.add(
      this.customerSearchService.list$.subscribe((resp:any) => {
        const customerList = resp?.customers;
        if (
          customerList &&
          customerList.length > 0 &&
          (this.selectedCustomer || this.userAccountApiRespAccountNumber)
        ) {
          const referenceCustNumber =
            this.selectedCustomer?.customerNumber ||
            this.userAccountApiRespAccountNumber;
          const customertosetcontext = customerList.find(
            (customer) => customer.customerNumber === referenceCustNumber
          );
          if (customertosetcontext) {
            this.customerContextService.set(customertosetcontext);
          }
        }
      })
    );

    this.knBrCommonService
      .getMiniCartOpen()
      .subscribe((res) => (this.isOpenMiniCartDropdown = res));

    this.subscription.add(
      this.cartContext$.subscribe((code) => {
        // todo
        if (!code) {
          return;
        }
        this.multiCartFacade.reloadCart(code);
        this.miniCart$ = this.multiCartFacade.getCart(code).pipe(
          filter((cart) => !!cart),
          map((cart) => cart)
        );
      })
    );
    this.cartEntries$ = this.activeCartService
      .getEntries()
      .pipe(filter((entries) => entries.length > 0));
  }

  showMiniCart() {
    const currentUrl = this.router.url;
    const excludeMiniCart = ["cwtcart-detail", "checkout", "register"];
    if (excludeMiniCart.some((route) => currentUrl.includes(route))) {
      return false;
    } else {
      this.knBrCommonService.setMiniCartOpen(true);
    }
  }

  hideMiniCart() {
    this.knBrCommonService.setMiniCartOpen(false);
  }

  goToLocation(url) {
    if (this.showEditCartConfirmationDialog) {
      this.openEditCartConfirmationPopup();
    } else {
      this.knBrCommonService.setMiniCartOpen(false);
      this.subscription.add(
        this.KnBrCheckoutService.setDefaultDeliveryMode().subscribe(() => {
          this.routing.goByUrl(url);
        })
      );
    }
  }

  openEditCartConfirmationPopup() {
    this.modalRef = this.modalService.open(EditCartConfirmationModalComponent, {
      centered: true,
      size: "lg",
    });
    this.modalRef.componentInstance.destinationUrl = '/cwtcart-detail'
  }

  changeCustomerContext(soldToAccountsList?) {
    let modalInstance: any;
    this.modalRef = this.modalService.open(ContextModalComponent, {
      centered: true,
      size: "lg",
      backdrop: "static",
      keyboard: false,
    });
    this.modalRef.componentInstance.soldToAccountsList = this.soldToAccountsList
      ? this.soldToAccountsList
      : soldToAccountsList;
    this.modalRef.componentInstance.selectedCustomerNumber = this
      .selectedCustomer?.customerNumber
      ? this.selectedCustomer?.customerNumber
      : null;
    modalInstance = this.modalRef.componentInstance;
  }

  logout() {
    this.authService.coreLogout();
    this.winRef.localStorage.clear();
    // this.newAuth0Service.logOutTheUser()
    // this.routing.goByUrl("/logout");
    this.newAuth0Service.logOutTheUser()
  }

  changeMenuState() {
    this.sidebarService.toggleMenuState();
  }

  toggle() {
    this.isActive = !this.isActive;
  }

  showCartPage(quantity: number) {
    if (!quantity) {
      this.router.navigate(["cwtcart-detail"]);
    }
  }

  closeSoldto() {
    this.isActive = false;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();  
    this.selectedCustomer = undefined;
    this.subscription?.unsubscribe();
  }
}